export function createOpenAccountAnimalHandler(
  entitlementId: string,
  onOpenAnimal: (entitlementId: string) => void,
) {
  return () => onOpenAnimal(entitlementId);
}
